import { ACCREDITATION_SERVICE_ENDPOINTS, ENDPOINTS_SEGMENTS } from '../../constants/endpoints';

import Api from '../../api';
import { FixMeLater } from '../../temporary-types';
import { IRequestPaginationParam } from '../../interfaces/IPagination';

export const fetchMyRequestsList = (params: IRequestPaginationParam): Promise<FixMeLater> => {
  const url = `${ACCREDITATION_SERVICE_ENDPOINTS.MY_REQUESTS}`;

  const response: Promise<FixMeLater> = Api.get(url, params);
  return response;
};

export const fetchMyRequestsDetails = (requestId: string): Promise<FixMeLater> => {
  const url = `${ACCREDITATION_SERVICE_ENDPOINTS.MY_REQUESTS_DETAILS.replace(':requestId', requestId)}`;
  const response: Promise<FixMeLater> = Api.get(url);
  return response;
};

export const downloadTicketRequest = (requestId: string): Promise<FixMeLater> => {
  const url = ACCREDITATION_SERVICE_ENDPOINTS.DOWNLOAD_TICKET.replace(':requestId', requestId);
  return Api.get(url);
};

export const getAccreditationTaskStatus = (taskId: string): Promise<FixMeLater> => {
  const url = ACCREDITATION_SERVICE_ENDPOINTS.GET_PDF_RESOURCE_LOCATION.replace(ENDPOINTS_SEGMENTS.TASK_ID, taskId);
  return Api.get(url);
};

export const updateRequest = (requestId: string, payload: FixMeLater): Promise<FixMeLater> => {
  const url = ACCREDITATION_SERVICE_ENDPOINTS.UPDATE_REQUEST.replace(':requestId', requestId);
  return Api.patch(url, payload);
};